import React, { useEffect, useState, useCallback } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Button,
  ModalBody,
  Box,
  Text,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { ComponentToPrint } from "../ComponentToPrint";
import { API } from "../../../main/config";
import ServicoAcolhimentoService from "../../../main/services/ServicoAcolhimentoService";
import LoadingSpinner from "../LoadingSpinner";

const ServicoPreviewModal = ({ isOpen, onClose, idSA }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const beforeGetContent = useCallback(async () => {
    setLoading(true);
    try {
      const res = await ServicoAcolhimentoService.dadosImpressao(idSA);
      const { planejamentoServicoAcolhimento, servicoAcolhimento, ...resto } =
        res.data;

      const tempPlanejamento = planejamentoServicoAcolhimento
        ? [
            {
              documento: "Plano de Trabalho",
              data:
                res.data.planejamentoServicoAcolhimento.possuiPlanoTrabalho ===
                "S"
                  ? res.data.planejamentoServicoAcolhimento
                      .dataAtualizacaoPlanoTrabalho
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataAtualizacaoPlanoTrabalho,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
            {
              documento: "Projeto Político-Pedagógico",
              data:
                res.data.planejamentoServicoAcolhimento.possuiPPP === "S"
                  ? res.data.planejamentoServicoAcolhimento.dataAtualizacaoPPP
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataAtualizacaoPPP,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
            {
              documento: "Relatório Anual",
              data:
                res.data.planejamentoServicoAcolhimento.possuiRelatorioAnual ===
                "S"
                  ? res.data.planejamentoServicoAcolhimento
                      .dataApresentacaoRelatorio
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataApresentacaoRelatorio,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
            {
              documento: "Regimento Interno",
              data:
                res.data.planejamentoServicoAcolhimento
                  .possuiRegimentoInterno === "S"
                  ? res.data.planejamentoServicoAcolhimento
                      .dataAtualizacaoRegimento
                    ? format(
                        res.data.planejamentoServicoAcolhimento
                          .dataAtualizacaoRegimento,
                        "dd/MM/yyyy"
                      )
                    : ""
                  : "Não possui",
            },
          ]
        : null;

      setData({
        planejamentoServicoAcolhimento: tempPlanejamento,
        servicoAcolhimento: {
          linkImagem:
            API + `/servico-acolhimento/logo/${servicoAcolhimento.id}`,
          ...servicoAcolhimento,
        },
        ...resto,
      });
      setLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressão");
      setLoading(false);
    }
  }, [idSA, setData, setLoading]);

  useEffect(() => {
    idSA && beforeGetContent();
  }, [beforeGetContent, idSA]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      scrollBehavior={"inside"}
    >
      <ModalOverlay />
      <ModalContent
        p={{ base: "5px", sm: "15px", md: "25px" }}
        w={{ base: "100%", lg: "70%" }}
        bgColor="#FFF"
      >
        <ModalHeader>
          <Text
            fontWeight={700}
            fontSize="20px"
            lineHeight="21.6px"
            color="#464648"
          >
            {"Ficha do serviço de acolhimento".toUpperCase()}
          </Text>
        </ModalHeader>

        <ModalBody
          p="0px"
          mt="25px"
          minH={{ base: "0px", md: "200px" }}
          pl="1px"
        >
          {!loading ? (
            <Box>
              <ComponentToPrint
                idSA={idSA}
                dataSA={data ? data.servicoAcolhimento : null}
                dataPerfil={data ? data.perfilServicoAcolhimento : null}
                dataGestao={data ? data.gestaoServicoAcolhimento : null}
                dataRegularidade={
                  data ? data.regularidadeServicoAcolhimento : null
                }
                dataPlanejamento={
                  data ? data.planejamentoServicoAcolhimento : null
                }
                dataEquipe={data ? data.membros : null}
                dataRedeReferencia={data ? data.redeReferencia : null}
                dataVoluntariado={data ? data.voluntariados : null}
                dataPessoaEmCumprimento={data ? data.pessoas : null}
                dataFamiliaAcolhedora={data ? data.familias : null}
                dataAnexos={data ? data.anexos : null}
                previewLayout={true}
              />
            </Box>
          ) : (
            <LoadingSpinner />
          )}
        </ModalBody>

        <ModalFooter display={"flex"}>
          <Button
            onClick={onClose}
            color="#FFF"
            m={"auto"}
            backgroundColor="#169499"
            fontWeight={700}
            px={"10"}
            fontSize="15px"
            lineHeight="21.6px"
            _hover={{ bg: "#169499" }}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ServicoPreviewModal;
